import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Paper from 'components/system/Paper';
import Loading from 'components/system/Loading';
import { useGetPayments } from 'hooks/useBillingAccount';
import colors from 'styles/colors';

const styles = {
  chipSuccess: {
    background: 'rgba(102, 187, 106, 0.12) !important',
    color: '#66BB6A !important',
  },
  chipError: {
    background: 'rgba(244, 67, 54, 0.12)',
    color: '#F44336',
  },
};

const statusMap = {
  succeeded: {
    label: 'OK',
    styles: styles.chipSuccess,
  },
  error: {
    label: 'Error',
    styles: styles.chipError,
  },
};

const TransactionHistory = () => {
  const { data, totalCount, isLoading } = useGetPayments();

  let content;

  if (totalCount === 0) {
    content = (
      <caption style={{ textAlign: 'center', padding: '50px 0 24px 0' }}>
        <Typography
          variant="body1"
          sx={{ color: colors.text.primary }}
        >
          Your transactions will appear here 🎉
        </Typography>
      </caption>
    );
  } else {
    content = (
      <TableBody>
        {data?.map(({
          date, amount, status, paymentId, receiptLink,
        }) => (
          <TableRow
            key={paymentId}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell align="left">{date}</TableCell>
            <TableCell align="right">{amount}</TableCell>
            <TableCell align="center">
              <Chip
                label={statusMap[status].label}
                variant="contained"
                sx={statusMap[status].styles}
              />
            </TableCell>
            <TableCell align="center">
              <a style={{ textDecoration: 'none' }} target="_blank" href={receiptLink} rel="noreferrer">
                <Button type="secondary" variant="contained">
                  View Invoice
                </Button>
              </a>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    );
  }

  return (
    <Paper sx={{ overflowX: 'auto' }}>
      <Typography variant="h6" sx={{ color: colors.text.primary }}>
        Transactions
      </Typography>
      {
        isLoading ? (
          <Loading />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Date</TableCell>
                <TableCell align="right">Amount</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            {content}
          </Table>
        )
      }
    </Paper>
  );
};

export default TransactionHistory;
